export function sortPromotions() {
    document.querySelectorAll(".promotions").forEach(promotionsContainer => {
        const promotions = Array.from(promotionsContainer.children);
        promotions.sort((a, b) => b.textContent.trim().length - a.textContent.trim().length);
        promotions.forEach(promo => promotionsContainer.appendChild(promo));
    });
}
